import {
    AUTH_LOGIN_REQUEST,
    AUTH_LOGIN_SUCCESS,
    SecurityState,
    SecurityActionTypes,
    AUTH_INIT_REQUEST,
    AUTH_INIT_SUCCESS,
    AUTH_INIT_FAIL,
    AUTH_LOGIN_FAIL,
    AUTH_SET_ACCOUNT_URL,
    AUTH_SET_USER_PROFILE,
    AUTH_SET_USER_ROLES,
    AUTH_SET_TOKEN,
    AUTH_LOGOUT_SUCCESS,
    AUTH_LOGOUT_FAIL,
} from './types';
import { SECURITY_USER_PROFILE_DEFAULT, SECURITY_INIT_OPTIONS_DEFAULT } from './defaults';

const initialState = {
    isLogged: false,
    isLoading: false,
    isFailed: false,
    user: SECURITY_USER_PROFILE_DEFAULT,
    roles: [],
    accountUrl: '',
    options: SECURITY_INIT_OPTIONS_DEFAULT,
    token: '',
};
const SecurityReducer = (
    state: SecurityState = initialState,
    action: SecurityActionTypes
): SecurityState => {
    switch (action.type) {
        case AUTH_INIT_REQUEST:
            return {
                ...state,
                isLogged: false,
                isLoading: true,
                isFailed: false,
                options: action.payload,
            };
        case AUTH_INIT_SUCCESS:
            return {
                ...state,
                isLogged: true,
                isLoading: false,
                isFailed: false,
            };
        case AUTH_INIT_FAIL:
            return {
                ...state,
                isLogged: false,
                isLoading: false,
                isFailed: true,
            };
        case AUTH_LOGIN_REQUEST:
            return {
                ...state,
                isLogged: false,
                isLoading: true,
                isFailed: false,
            };
        case AUTH_LOGIN_SUCCESS:
            return {
                ...state,
                isLogged: true,
                isLoading: false,
                isFailed: false,
            };
        case AUTH_LOGIN_FAIL:
            return {
                ...state,
                isLoading: false,
                isLogged: false,
                isFailed: false,
            };
        case AUTH_LOGOUT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isLogged: false,
                isFailed: false,
                user: SECURITY_USER_PROFILE_DEFAULT,
                accountUrl: '',
            };
        case AUTH_LOGOUT_FAIL:
            return {
                ...state,
                isLoading: false,
                isLogged: false,
                isFailed: true,
                user: SECURITY_USER_PROFILE_DEFAULT,
                accountUrl: '',
            };
        case AUTH_SET_ACCOUNT_URL:
            return {
                ...state,
                accountUrl: action.payload,
            };
        case AUTH_SET_USER_PROFILE:
            return {
                ...state,
                user: action.payload,
            };
        case AUTH_SET_USER_ROLES:
            return {
                ...state,
                roles: action.payload,
            };
        case AUTH_SET_TOKEN:
            return {
                ...state,
                token: action.payload,
            };
        default:
            return state;
    }
};

export default SecurityReducer;
